// extracted by mini-css-extract-plugin
export default {"ProtocolUpdateWrap":"ProtocolUpdateModal_ProtocolUpdateWrap__8oEWU"};